/* global axios */
import ApiClient from './ApiClient';

// FR2 — Multiple contacts/conversations per Pipeline card. These joins are
// purely additive: the primary link stays pipeline_cards.contact_id /
// conversation_display_id (retrocompat with automations/webhooks/n8n/MCP/
// customer API). Backend: Api::V1::Accounts::Pipeline::CardContactsController
// / CardConversationsController.
//
// The routes live under /pipeline/cards/:card_id/(contacts|conversations),
// not /pipeline_cards/:id — mirrors the remap already done in leadScores.js.
class PipelineCardLinksAPI extends ApiClient {
  constructor() {
    super('pipeline_cards', { accountScoped: true });
  }

  addContact(cardId, contactId, role = null) {
    const baseUrl = this.url.replace('/pipeline_cards', '/pipeline/cards');
    const payload = { contact_id: contactId };
    if (role) payload.role = role;
    return axios.post(`${baseUrl}/${cardId}/contacts`, payload);
  }

  removeContact(cardId, joinId) {
    const baseUrl = this.url.replace('/pipeline_cards', '/pipeline/cards');
    return axios.delete(`${baseUrl}/${cardId}/contacts/${joinId}`);
  }

  addConversation(cardId, conversationDisplayId) {
    const baseUrl = this.url.replace('/pipeline_cards', '/pipeline/cards');
    return axios.post(`${baseUrl}/${cardId}/conversations`, {
      conversation_display_id: conversationDisplayId,
    });
  }

  removeConversation(cardId, joinId) {
    const baseUrl = this.url.replace('/pipeline_cards', '/pipeline/cards');
    return axios.delete(`${baseUrl}/${cardId}/conversations/${joinId}`);
  }
}

export default new PipelineCardLinksAPI();
